import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import setFolder from 'component/useFunModal/setFolder'
import { useParams } from 'react-router-dom'
import styles from './index.module.less'

export default ({ style, onClick }) => {
  const { folderId } = useParams()
  const _onClick = () => {
    setFolder?.({
      value: { parentId: folderId },
      onOk: (val) => {
        onClick?.(val)
      }
    })
  }
  return <div className={styles['mn-child-create-file']} style={style} onClick={_onClick}>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Icon type="m-xinjianlingganji" className={styles['mn-child-create-file-icon']} />
      <div className={styles['mn-child-create-file-info']}>新建{folderId ? '子' : null}文件夹</div>
    </div>
    <Icon type="m-tianjia" className={styles['mn-child-create-file-add-icon']} />
  </div>
}
